import React from 'react';
import LimitTableFilter from '../../../components/limit/LimitTableFilter';
import styled from 'styled-components';

function CheckListLimitTable({ isRegion }: { isRegion?: boolean }) {
  return (
    <LimitTableFilter title="권리분석 체크 리스트는" isRegion={isRegion}>
      <div
        style={{
          borderTop: '1px solid #222',
        }}
      >
        <table
          style={{
            borderCollapse: 'collapse',
            borderSpacing: '0px',
            width: '100%',
          }}
        >
          <thead>
            <tr
              style={{
                width: '100%',
                // borderCollapse: 'separate',
              }}
            >
              <TableHeadTh width={'20%'}>순위</TableHeadTh>
              <TableHeadTh width={'60%'}>종류</TableHeadTh>
              <TableHeadTh width={'20%'}>유무</TableHeadTh>
            </tr>
          </thead>
          <tbody>
            <tr
              style={{
                backgroundColor: '#E6F3FF',
                borderBottom: '1px solid #e1e2e4',
              }}
            >
              <TablebodyTd width={'20%'}>1순위</TablebodyTd>
              <TablebodyTd width={'60%'}>경매집행비용</TablebodyTd>
              <TablebodyTd width={'20%'}>있음</TablebodyTd>
            </tr>
          </tbody>
        </table>
      </div>
    </LimitTableFilter>
  );
}

export default CheckListLimitTable;

const TableHeadTh = styled.th<{ width: string }>`
  width: ${({ width }) => width};
  text-align: center;
  padding: 10px 12px;
  background-color: #f7f8fc;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 18.85px; /* 26.1px */
  letter-spacing: -0.36px;
  color: #616161;

  border-right: 1px solid #e8e9ea;
  &:last-child {
    border-right: none;
  }
`;
const TablebodyTd = styled.td<{ width: string }>`
  width: ${({ width }) => width};
  text-align: center;

  padding: 10px 12px;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20.3px;
  letter-spacing: -0.32px;
  color: #008aff;

  border-right: 1px solid #e8e9ea;
  &:last-child {
    border-right: none;
  }
`;
